import React, { Component, useMemo } from 'react'
import PropTypes from 'prop-types';
import { find } from 'lodash';
import memoize from 'memoizee';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import i18n from 'cityads-v3/i18n';
import classNames from 'classnames';
import { parse } from 'query-string';

import {
  setGetLinkForm,
} from 'cityads-v3/actions/offers';

import {
  getShortLink
} from 'cityads-v3/actions/shortLink';

import {
  getWmOfferUrls
} from 'cityads-v3/actions/wmOfferUrls';

import withHooks from 'cityads-v3/decorators/withHooks';
import { useOfferInfoSender } from 'cityads-v3/hooks/amplitude';
import { useEntities } from 'cityads-v3/hooks/entities'
import { mindboxNotifyAddProductToList, yandexReachGoal } from 'cityads-v3/utils/counterUtils';
import { ParkedDomainType } from 'cityads-v3/hooks/domainParking'
import { useThemeChanger } from 'cityads-v3/hooks/theme'

import MenuItem from '@mui/material/MenuItem';

import Channels from 'cityads-v3/components/Forms/Channels';
import ParkedDomains from 'cityads-v3/components/TextField/ParkedDomains';
import Subaccounts from 'cityads-v3/components/Forms/Subaccounts';
import TextField from 'cityads-v3/components/TextField/TextField';
import Typography from '@mui/material/Typography'
import WidgetHider from 'cityads-v3/components/WidgetHider/WidgetHider'

import GetLinkTabPanelOffer from './GetLinkTabPanelOffer';
import GetLinkTabPanelGoogle from './GetLinkTabPanelGoogle';
import GetLinkTabPanelMicrosoft from './GetLinkTabPanelMicrosoft';

import classes from './OfferGetLink.scss';
import RadioField from 'cityads-v3/components/RadioField/RadioField'
import { useLocation } from 'react-router'

const LINK_TYPE_TAB_OFFER     = 'offer';
const LINK_TYPE_TAB_GOOGLE    = 'google';
const LINK_TYPE_TAB_MICROSOFT = 'microsoft';

const GOOGLE_TRACKING_TEMPLATE_SUFFIX = 'url={lpurl}&pt=1&no_cookie=1&no_js=1&foreign_click_id={gclid}';
const MICROSOFT_TRACKING_TEMPLATE_SUFFIX = 'url={lpurl}&pt=1&no_cookie=1&no_js=1&foreign_click_id={MSCLKID}';

@withHooks(props => {
  const { offerId } = props;
  const location = useLocation()
  const url = useMemo(() => parse(location.search)?.url, [location.search])

  const themeChanger = useThemeChanger()

  const sendOfferInfo = useOfferInfoSender(offerId);
  const [parkedDomains] = useEntities('parkedDomains');

  return {
    ...props,
    sendOfferInfo,
    parkedDomains,
    url,
    themeChanger,
  };
})
@connect(
  (state, props) => {
    const links = state.wmOfferUrls.urlsByOfferId[props.offerId] || {data: []};
    return {
      getLinkForm : state.offers.getLinkForm,
      channels    : state.channels.channelIds.map(item => state.channels.channelsById[item]),

      links          : links.data.map(item => links.dataById[item]),
      linksById      : links.dataById || {},
      linksIsLoading : links.isLoading,
      linksIsLoaded  : links.isLoaded,

      isShortLinkLoading : state.shortLink.isLoading['offer' + props.offerId],
      isShortLinkLoaded  : state.shortLink.isLoaded['offer' + props.offerId],
      shortLink          : state.shortLink.shortLinks['offer' + props.offerId],
    }
  }
)
@withTranslation(['Offers'], { i18n, wait: !!window })
export default class OfferGetLink extends Component {

  static propTypes = {
    offerId              : PropTypes.number.isRequired,
    getLinkForm          : PropTypes.object,
    channels             : PropTypes.array,
    isDeeplinkEnabled    : PropTypes.bool,
    isGoogleAdsEnabled   : PropTypes.bool,
    isMicrosoftAdsEnabled: PropTypes.bool,
    oneColumn: PropTypes.bool,

    links            : PropTypes.array,
    linksIsLoaded    : PropTypes.bool,
    linksIsLoading   : PropTypes.bool,
    isShortLinkLoaded: PropTypes.bool,
    showCode         : PropTypes.bool,
    showLinksSelector: PropTypes.bool,
    showTrackingTabs : PropTypes.bool,

    sendOfferInfo: PropTypes.func.isRequired,

    onChangeChannel  : PropTypes.func,
    onChangeCode     : PropTypes.func,
    onToggleShortLink: PropTypes.func,
    onCopyCode       : PropTypes.func,

    linkLabel: PropTypes.string,

    hasParkingPermission: PropTypes.bool,
    parkedDomainsLoading: PropTypes.bool,
    parkedDomains       : PropTypes.shape({ parkedDomain: PropTypes.array }),
  };

  static defaultProps = {
    showCode: true,
    showLinksSelector: true,
    showTrackingTabs: true,
  }

  state = {
    showTypePrelanding: true,
    showTypeTarget: true,
    isShortLink: false,
    isServerRedirect: false,
    linkTypeTab: LINK_TYPE_TAB_OFFER,
  }

  constructor(props) {
    super(props);

    this.getChannelsFilter = memoize(this.getChannelsFilter.bind(this));
  }

  componentDidMount() {
    const { offerId, linksIsLoaded, url, links } = this.props
    if (linksIsLoaded) {
      this.setForm({ type: url || links[0].id })
    } else {
      this.props.dispatch(getWmOfferUrls(offerId));
    }
  }

  componentDidUpdate() {
    const code = this.getCodeData().code;
    this.props.onChangeCode?.(code);
  }

  UNSAFE_componentWillReceiveProps(newProps) {

    if (
      this.props.linksIsLoading
      && newProps.linksIsLoading === false
      && newProps.linksIsLoaded === true
      && newProps.links[0]
    ) {
      this.setForm({ type: newProps.url || newProps.links[0].id });
    }

    if (this.props.offerId !== newProps.offerId) {
      this.props.dispatch(getWmOfferUrls(newProps.offerId))
    }

  }

  setForm(data) {
    this.props.dispatch(setGetLinkForm(data));
    this.setState({
      isShortLink: false
    });
  }

  getCodeData() {
    const { code, ...rest } = this.getSelectedLinkData() || {};

    const { shortLink, isShortLinkLoaded } = this.props;

    return {
      code: (this.state.isShortLink && isShortLinkLoaded) ? shortLink : (code || ''),
      ...rest
    };
  }

  getSelectedLinkData() {
    const { linksById, parkedDomains, getLinkForm } = this.props;
    const { type, url = '', domain, channel, subaccounts = [] } = getLinkForm;
    const selectedLink = linksById[type];
    const { isServerRedirect } = this.state;

    if (!type || !channel || !selectedLink) {
      return null;
    }

    const linkChannelData = selectedLink.links[channel];

    if (!linkChannelData) {
      return null;
    }

    const SAs = subaccounts
      .map((sa, num) => sa ? ('sa' + (num ? num+1 : '') + '=' + encodeURIComponent(sa)) : '')
      .filter(sa => sa)
      .join('&')
    ;

    const userArgs = [
      SAs,
      url ? 'url=' + encodeURIComponent(url) : ''
    ]
      .filter(item => item)
      .join('&')
    ;

    const {
      url: linkUrl,
      google_ads_final_url: googleFinalUrl,
      google_ads_final_url_suffix: googleFinalUrlSuffix,
      microsoft_ads_final_url: microsoftFinalUrl,
      microsoft_ads_final_url_suffix: microsoftFinalUrlSuffix,
      ord_token: ordToken,
    } = linkChannelData;

    const parsedLinkUrl = new URL(linkUrl);

    if (domain) {
      const selectedParkedDomain = find(parkedDomains?.parkedDomain ?? [], { id: domain });

      if (selectedParkedDomain) {
        parsedLinkUrl.host = selectedParkedDomain.domain;
      }
    }

    if (userArgs) {
      parsedLinkUrl.search += (parsedLinkUrl.search ? '&' : '') + userArgs;
    }

    const search = parsedLinkUrl.search;

    parsedLinkUrl.search = [
      search,
      isServerRedirect ? 'no_js=1' : null,
      ordToken ? 'erid=' + ordToken : null,
    ].filter(item => !!item).join('&')

    const code = parsedLinkUrl.toString();

    parsedLinkUrl.search = search + (search ? '&' : '') + GOOGLE_TRACKING_TEMPLATE_SUFFIX
      + (ordToken ? `&erid=${ordToken}` : '');

    const googleTrackingTemplate = parsedLinkUrl.toString();

    parsedLinkUrl.search = search + (search ? '&' : '') + MICROSOFT_TRACKING_TEMPLATE_SUFFIX
      + (ordToken ? `&erid=${ordToken}` : '');

    const microsoftTrackingTemplate = parsedLinkUrl.toString();

    return {
      code,
      googleFinalUrl,
      googleTrackingTemplate,
      googleFinalUrlSuffix,
      microsoftFinalUrl,
      microsoftTrackingTemplate,
      microsoftFinalUrlSuffix,
    };
  }

  setIsServerRedirect = (value) => {
    this.setState({
      isServerRedirect: value,
      isShortLink: false,
    })
  }

  toggleShortLink = () => {
    const { offerId, dispatch, onToggleShortLink } = this.props;
    const url = this.getCodeData().code;
    const newState = !this.state.isShortLink;

    this.setState({
      isShortLink: newState
    });

    if (newState) {
      dispatch(getShortLink(url, 'offer' + offerId));
    }

    onToggleShortLink?.(newState);
  }

  getChannelsFilter(getLinkForm, linksById) {
    return channel => linksById[getLinkForm.type]?.links[channel.id];
  }

  onSelectCode = (evt) => {
    const { dispatch, offerId } = this.props;

    dispatch(mindboxNotifyAddProductToList('Online.CopyLinkNew', offerId));
  }

  onCopyCode = (evt) => {
    const { dispatch, offerId, sendOfferInfo, onCopyCode } = this.props;

    dispatch(mindboxNotifyAddProductToList('Online.CopyLinkNewBut', offerId));

    sendOfferInfo('d-v1-e9', 'url_get');

    onCopyCode?.();
  }

  handleLinkTypeTabChange = (evt, newValue) => {
    this.setState({ linkTypeTab: newValue });

    if (newValue === LINK_TYPE_TAB_GOOGLE) {
      yandexReachGoal('CLICK_LINK_TYPE_TAB_GOOGLE')
    }
  }

  handleChannelChange = (value, reason) => {
    this.setForm({ channel: value });
    this.props.onChangeChannel?.(value, reason);
  }

  handleLinkTypeTabChange = (evt, newValue) => {
    this.setState({ linkTypeTab: newValue });

    if (newValue === LINK_TYPE_TAB_GOOGLE) {
      yandexReachGoal('CLICK_LINK_TYPE_TAB_GOOGLE')
    }
  }

  render() {
    const {
      getLinkForm,
      t,
      offerId,
      links,
      linksById,
      isDeeplinkEnabled,
      isGoogleAdsEnabled,
      isMicrosoftAdsEnabled,
      className,
      gridClassName,
      showCode,
      showLinksSelector,
      showTrackingTabs,
      linkLabel,
      isInDialog,
      oneColumn,
      themeChanger,
    } = this.props;
    const { linkTypeTab } = this.state;

    const {
      code,
      googleFinalUrl,
      googleTrackingTemplate,
      googleFinalUrlSuffix,
      microsoftFinalUrl,
      microsoftTrackingTemplate,
      microsoftFinalUrlSuffix,
    } = this.getCodeData();

    const subaccountLength = getLinkForm.subaccounts?.length ?? 1
    const activeTrackingTabs = [
      {
        nameA: t('exports.linkTypeOffer'),
        value: LINK_TYPE_TAB_OFFER,
        image: themeChanger.themeName === 'dark' ? require('./img/tracking/cityads_dark.svg') : require('./img/tracking/cityads.svg'),
        tooltip: t('exports.linkTypeOfferHint')
      },
      (showTrackingTabs && isGoogleAdsEnabled) ? {
        nameA: t('exports.linkTypeGoogle'),
        value: LINK_TYPE_TAB_GOOGLE,
        image: require('./img/tracking/google.svg'),
        tooltip: t('exports.linkTypeParallelTrafficHint')
      } : null,
      (showTrackingTabs && isMicrosoftAdsEnabled) ? {
        nameA: t('exports.linkTypeMicrosoft'),
        value: LINK_TYPE_TAB_MICROSOFT,
        image: require('./img/tracking/microsoft.svg'),
        tooltip: t('exports.linkTypeParallelTrafficHint')
      } : null,
    ].filter(Boolean)

    return (
      <div className={classNames(classes.getLinkForm, className)}>
        <WidgetHider variant="mobile" />
        <div className={classNames(classes.grid, gridClassName)}>
          <div
            className={classes.gridLinkSettings}
            style={isInDialog ? {
              gridTemplateRows: `repeat(${subaccountLength}, 1fr)`,
            } : null}
          >
            {showLinksSelector ? (
              <>
                <TextField
                  select
                  label={t('exports.urlSettings')}
                  value={getLinkForm.type || ''}
                  onChange={evt => {
                    this.setForm({ type: evt.target.value })
                  }}
                  fullWidth={true}
                >
                  {links.map(item => (
                    <MenuItem
                      key={item.id}
                      value={item.id}
                    >
                      {item.translated_name}
                    </MenuItem>
                  ))}
                </TextField>
              </>
            ) : null}

            <Subaccounts
              className={classes.subaccounts}
              style={{
                gridRow: `auto / span ${subaccountLength}`,
                minHeight: `calc(54.5px * ${subaccountLength - 1})`
              }}
              textFieldClasses={{
                root: classNames({
                  [classes.subaccountTextField]: isInDialog,
                  [classes.subaccountsOneColumn]: oneColumn
                })
              }}
              value={getLinkForm.subaccounts}
              onChange={value => this.setForm({ subaccounts: value })}
            />

            <Channels
              value={getLinkForm.channel}
              filter={this.getChannelsFilter(getLinkForm, linksById)}
              onChange={this.handleChannelChange}
            />

            <ParkedDomains
              fullWidth={true}
              onChange={evt => {
                this.setForm({ domain: evt.target.value })
              }}
              domainType={ParkedDomainType.links}
              value={getLinkForm.domain}
            />

            {isDeeplinkEnabled ? (
              <TextField
                label={t('exports.deeplink')}
                fullWidth={true}
                value={getLinkForm.url || ''}
                onChange={evt => this.setForm({ url: evt.target.value })}
                InputLabelProps={{ shrink: true }}
              />
            ) : false}

          </div>
        </div>
        {activeTrackingTabs.length > 1 ? (
          <div>
            <Typography gutterBottom>{t('exports.chooseTracking')}</Typography>
            <RadioField
              withImages
              items={activeTrackingTabs}
              imageHeight={46}
              onChange={this.handleLinkTypeTabChange}
              value={linkTypeTab}
            />
          </div>
        ) : null}

        {showCode ?
          (
            <>
              {linkTypeTab === LINK_TYPE_TAB_OFFER ?
                (
                  <GetLinkTabPanelOffer
                    isServerRedirect  = {this.state.isServerRedirect}
                    onChangeRedirect  = {this.setIsServerRedirect}
                    code              = {code}
                    onSelectCode      = {this.onSelectCode}
                    onCopyCode        = {this.onCopyCode}
                    isShortLink       = {this.state.isShortLink}
                    onToggleShortLink = {this.toggleShortLink}
                    linkLabel         = {linkLabel}
                  />
                ) :
                null
              }
              {linkTypeTab === LINK_TYPE_TAB_GOOGLE ?
                (
                  <GetLinkTabPanelGoogle
                    offerId          = {offerId}
                    finalUrl         = {googleFinalUrl}
                    trackingTemplate = {googleTrackingTemplate}
                    finalUrlSuffix   = {googleFinalUrlSuffix}
                  />
                ) :
                null
              }
              {linkTypeTab === LINK_TYPE_TAB_MICROSOFT ?
                (
                  <GetLinkTabPanelMicrosoft
                    offerId={offerId}
                    finalUrl         = {microsoftFinalUrl}
                    trackingTemplate = {microsoftTrackingTemplate}
                    finalUrlSuffix   = {microsoftFinalUrlSuffix}
                  />
                ) :
                null
              }
            </>
          ) :
          null
        }
      </div>
    );
  }

}
